import { Button } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import { ClassNameMap } from '@material-ui/core/styles/withStyles'
import { Routes } from 'common/routeConfig'
import MailTo from 'components/mailTo/mailTo'
import { t } from 'i18next'
import { Trans } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import StaticPageTypography from './StaticPageTypography'

type ContactAndButtonBlockProps = {
    styles: ClassNameMap
    isLargeScreen: boolean
    withHomeButton?: boolean
    withLoginButton?: boolean
    withContact?: boolean
}

const ContactAndButtonBlock = ({
    styles,
    isLargeScreen,
    withContact,
    withHomeButton,
    withLoginButton
}: ContactAndButtonBlockProps) => {
    const navigate = useNavigate()

    const handleHomeClick = () => {
        navigate(Routes.BASE)
        window.location.reload()
    }
    return (
        <>
            {withHomeButton && (
                <Button
                    className={styles.goBackButton}
                    variant="contained"
                    onClick={handleHomeClick}
                >
                    {t<string>('common:buttons.goBackHome')}
                </Button>
            )}
            {withLoginButton && (
                <Button
                    className={styles.goBackButton}
                    variant="contained"
                    onClick={handleHomeClick}
                >
                    {t<string>('common:buttons.login')}
                </Button>
            )}
            {withContact && (
                <Box>
                    <StaticPageTypography
                        component="div"
                        variant={isLargeScreen ? 'body2' : 'caption'}
                    >
                        <Trans i18nKey="common:contact.haveQuestions">
                            If you have any questions
                        </Trans>
                        {', '}
                        <Trans i18nKey="common:contact.contactUsAnyTime">
                            please feel free to contact us any time at
                        </Trans>{' '}
                        <MailTo
                            email="support@genomate.health"
                            typographyProps={{
                                className: styles.emailLink,
                                variant: isLargeScreen ? 'body2' : 'caption'
                            }}
                        />
                    </StaticPageTypography>
                </Box>
            )}
        </>
    )
}

export default ContactAndButtonBlock
